<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="12" :lg="12" :md="12" :sm="24">
              <a-form-item label="试卷">
                <j-search-select-tag placeholder="请选择试卷" v-model="queryParam.paperId"
                  dict="teaching_paper,paper_name,id" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="班级">
                <j-select-depart v-model="queryParam.deptId" :multi="true"></j-select-depart>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="答题卡ID">
                <a-input placeholder="答题卡ID" v-model="queryParam.id" />
              </a-form-item>
            </a-col>
            
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="用户ID">
                <a-input placeholder="请输入用户ID" v-model="queryParam.userId" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="账号">
                <a-input placeholder="请输入学生账号" v-model="queryParam.username" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="姓名">
                <a-input placeholder="请输入学生姓名" v-model="queryParam.realname" />
              </a-form-item>
            </a-col>
            <template v-if="toggleSearchStatus">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="选择用户">
                  <j-select-user-by-dep placeholder="请选择用户" v-model="queryParam.userId" />
                </a-form-item>
              </a-col>
              <a-col :xl="5" :lg="6" :md="7" :sm="24">
                <a-form-item label="状态">
                  <j-dict-select-tag type="list" v-model="queryParam.userPaperStatus" dictCode="user_paper_status"
                    placeholder="请选择试卷状态" />
                </a-form-item>
              </a-col>
              <a-col :xl="10" :lg="11" :md="12" :sm="24">
                <a-form-item label="交卷时间">
                  <j-date v-model="queryParam.submitTime_begin" :showTime="true" date-format="YYYY-MM-DD HH:mm:ss"
                    style="width:45%" placeholder="请选择开始时间"></j-date>
                  <span class="query-group-split-cust"></span>
                  <j-date v-model="queryParam.submitTime_end" :showTime="true" date-format="YYYY-MM-DD HH:mm:ss"
                    style="width:45%" placeholder="请选择结束时间"></j-date>
                </a-form-item>
              </a-col>
              <a-col :xl="5" :lg="6" :md="7" :sm="24">
                <a-form-item label="总得分">
                  <a-input placeholder="请输入最小值" class="query-group-cust" v-model="queryParam.gotScore_begin"></a-input>
                  <span class="query-group-split-cust"></span>
                  <a-input placeholder="请输入最大值" class="query-group-cust" v-model="queryParam.gotScore_end"></a-input>
                </a-form-item>
              </a-col>
              <!-- <a-col :xl="10" :lg="11" :md="12" :sm="24">
                <a-form-item label="排名">
                  <a-input
                    placeholder="请输入最小值"
                    class="query-group-cust"
                    v-model="queryParam.ranking_begin"
                  ></a-input>
                  <span class="query-group-split-cust"></span>
                  <a-input placeholder="请输入最大值" class="query-group-cust" v-model="queryParam.ranking_end"></a-input>
                </a-form-item>
              </a-col> -->
              <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="比赛">
                  <j-search-select-tag placeholder="请选择比赛ID" v-model="queryParam.contestId"
                    dict="teaching_contest,contest_name,id" />
                </a-form-item>
              </a-col> -->
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? '收起' : '展开' }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      <!-- table区域-begin -->
      <div>
        <a-table ref="table" size="middle" bordered rowKey="id" class="j-table-force-nowrap" :scroll="{ x: true }"
          :columns="columns" :dataSource="dataSource" :pagination="ipagination" :loading="loading" @change="handleTableChange">
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <template slot="imgSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
            <img v-else :src="getImgView(text)" :preview="text" height="25px" alt=""
              style="max-width: 80px; font-size: 12px; font-style: italic" />
          </template>
          <template slot="fileSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
            <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
              下载
            </a-button>
          </template>
  
          <span slot="action" slot-scope="text, record">
            <a @click="handleReview(record)">{{ record.userPaperStatus > 0 ? '批改' : '查看试卷' }}</a>
            <a-divider type="vertical" />
            <a @click="handleAutoReview(record)" v-if="(record.userPaperStatus >= 1)">自动批改</a>
            <a-divider type="vertical" v-if="(record.userPaperStatus >= 1)" />
            <a @click="handleInvigilate(record)">监考数据</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">更多
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)">原始数据</a>
                </a-menu-item>
                <a-menu-item>
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
      </div>
  
      <teaching-user-paper-modal ref="modalForm" @ok="modalFormOk" />
      <j-modal :title="'监考数据——' + invigilateUser" :visible="invigilateVisible" width="900" switchFullscreen fullscreen
      :destroyOnClose="true" :footer="null"
        @cancel="invigilateVisible = false">
        <TeachingUserPaperLogList ref="userPaperLog" />
      </j-modal>
    </a-card>
  </template>
  
  <script>
  import { getAction,deleteAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TeachingUserPaperModal from './components/student/TeachingUserPaperModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import '@/assets/less/TableExpand.less'
  import JDate from '@/components/jeecg/JDate'
  import TeachingUserPaperLogList from './components/student/TeachingUserPaperLogList'
  
  export default {
    name: 'TeachingUserPaperList',
    mixins: [JeecgListMixin],
    components: {
      JSelectUserByDep,
      JSearchSelectTag,
      TeachingUserPaperModal,
      JSelectDepart,
      JDate,
      TeachingUserPaperLogList
    },
    data() {
      return {
        description: '用户答卷管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            fixed:"left",
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            },
          },
          {
            title: '答题卡ID',
            align: 'center',
            width: 120,
            dataIndex: 'id',
            sorter: true
          },
          {
            title: "试卷",
            align: "center",
            dataIndex: "paperId_dictText"
          },
          {
            title: "班级",
            align: "center",
            dataIndex: "deptId_dictText"
          },
          {
            title: '账号',
            align: 'center',
            dataIndex: 'username',
            sorter: true
          },
          {
            title: '姓名',
            align: 'center',
            dataIndex: 'realname',
            sorter: true
          },
          {
            title: '状态',
            align: 'center',
            dataIndex: 'userPaperStatus_dictText',
            sorter: true
          },
          {
            title: '用时',
            align: 'center',
            dataIndex: 'duration',
            sorter: true,
            customRender(time, row) {
              if (row.userPaperStatus == 0) {
                return ""
              }
              var minutes = Math.floor(time / 60)
              var seconds = Math.floor(time % 60)
              return minutes + ':' + seconds
            },
          },
          {
            title: '页面跳出次数',
            align: 'center',
            width: 100,
            dataIndex: 'jumpOutTimes',
            sorter: true
          },
          {
            title: '总得分',
            align: 'center',
            dataIndex: 'gotScore',
            sorter: true,
          },
          // {
          //   title: '排名',
          //   align: 'center',
          //   dataIndex: 'ranking',
          // },
          // {
          //   title: '关联比赛',
          //   align: 'center',
          //   dataIndex: 'contestId_dictText',
          // },
          {
            title: '开考时间',
            align: 'center',
            dataIndex: 'createTime',
            sorter: true,
          },
          {
            title: '交卷时间',
            align: 'center',
            dataIndex: 'submitTime',
            sorter: true,
          },
          {
            title: '批改时间',
            align: 'center',
            dataIndex: 'reviewTime',
            sorter: true,
          },
          {
            title: '批改人',
            align: 'center',
            dataIndex: 'reviewUserId_dictText',
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' },
          },
        ],
        url: {
          list: '/teaching/teachingUserPaper/list',
          delete: '/teaching/teachingUserPaper/delete',
          deleteBatch: '/teaching/teachingUserPaper/deleteBatch',
          exportXlsUrl: '/teaching/teachingUserPaper/exportXls',
          importExcelUrl: 'teaching/teachingUserPaper/importExcel',
        },
        dictOptions: {},
        invigilateVisible: false, 
        invigilateUser: '' //正在监考的用户
      }
    },
    created() { },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      },
    },
    methods: {
      initDictConfig() { },
      handleReview(record) {
        let route = this.$router.resolve({
          path: '/examReview',
          query: {
            id: record.id,
          },
        })
        window.open(route.href, '_blank')
      },
      handleInvigilate(record) {
        this.invigilateVisible = true
        this.invigilateUser = record.realname || record.username
        this.$nextTick(() => {
          this.$refs.userPaperLog.showPaperLog(record.id)
        })
      },
      handleAutoReview(record) {
        getAction('/teaching/teachingPaper/autoJudge?userPaperId=' + record.id).then((res) => {
          this.$notification.success({
            message: '自动批改完成',
            description: res.message,
          })
          this.searchQuery()
        })
      },
      searchQuery(){
        this.loadData();
      },
      batchDelLog(){
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！');
          return;
        } else {
          var ids = "";
          for (var a = 0; a < this.selectedRowKeys.length; a++) {
            ids += this.selectedRowKeys[a] + ",";
          }
          var that = this;
          this.$confirm({
            title: "确认删除",
            content: "是否删除选中考卷的监考文件?",
            onOk: function () {
              deleteAction("/teaching/teachingUserPaper/deleteBatchLog", {ids: ids}).then((res) => {
                if (res.success) {
                  that.$message.success(res.result);
                } else {
                  that.$message.warning(res.message);
                }
              }).finally(() => {
              });
            }
          });
        }
      }
    },
  }
  </script>
  <style scoped>
  @import '~@assets/less/common.less';
  </style>